import { apiService } from "../api";



/**
 * 4. POST /customer/program/{program_id}
 */
export async function createCustomerProgram(programId: string, payload: object) {
  const response = await apiService({
    url: `/customer/program/${programId}`,
    method: "post",
    protectedRoute: true,
    requestData: payload,
  });
  return response;
}

/**
 * 5. GET /customer/program/{program_id}
 */
export async function getCustomerProgram(programId: string) {
  const response = await apiService({
    url: `/customer/program/${programId}`,
    method: "get",
    protectedRoute: true,
  });
  return response;
}